/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette } from 'config';
import { useDispatch } from 'react-redux';
import { ErrorComponent, Loader } from 'components';
import SettingsMain from 'components/accountSettings/SettingsMain';
import { accountSettingsAPI } from 'services/accountSettings.service';

const AccountSettingsPage = () => {
  const dispatch = useDispatch();
  const { data, isError, isSuccess, isFetching, isLoading } =
    accountSettingsAPI.useGetAccountSettingsDataQuery();

  if (window.REACT_APP_ENV !== 'qa') {
    return (
      <h2 style={{ color: 'red', textAlign: 'center', marginTop: '132px' }}>
        This page available only for QA mode
      </h2>
    );
  }
  if (isLoading) {
    return <Loader.Global delay={0} />;
  }

  if (isError) {
    return <ErrorComponent />;
  }

  return (
    <Box>
      <PageMainHeader>Account Settings</PageMainHeader>
      <SettingsMain />
    </Box>
  );
};

export default AccountSettingsPage;

const Box = styled.div`
  display: grid;
  width: 1002px;
  margin: 0 auto;
`;

const PageMainHeader = styled.h1`
  width: 100%;
  padding: 48px 0;
  margin: 0 auto;
  font-size: 40px;
  color: ${Palette.PrimaryGray._900};
  font-style: normal;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: -0.8px;
`;
